<section class="w-full font-display p-4 sm:p-6">
  <div class="w-full flex flex-col space-y-4 justify-center items-center">
    <span class="text-xl sm:text-2xl font-semibold text-center">{{
      data?.title ?? "-"
    }}</span>
    <span class="text-[#767676] text-center w-full sm:w-4/5">{{
      data?.message ?? "-"
    }}</span>
  </div>
  <div class="flex w-full items-center justify-center mt-6">
    @if (data?.success) {
    <i class="fa-regular fa-circle-check text-5xl sm:text-6xl text-[#3DB474]"></i>
    } @else {
    <i class="fa-regular fa-circle-xmark text-5xl sm:text-6xl text-[#df4e4e]"></i>
    }
  </div>
  <div class="flex w-full items-center justify-center mt-8">
    <button
      (click)="closeDialog()"
      class="w-full sm:w-64 h-12 rounded-lg bg-[#8C8C8C] text-white flex items-center justify-center space-x-2 focus:outline-none"
    >
      Close
    </button>
  </div>
</section>
